import { templateThemeTokens } from './templateThemeTokens.js';
import { THEME_DEFAULT_FONTS } from '@/contexts/CustomThemeConfigContext/constants.js';
import { createTheme } from '@/stitches/index.js';

export const dusk = createTheme({
  ...templateThemeTokens,
  colors: {
    defaultFont: '#ECE7EE',
    pageBackground: '#343035',
    secondaryFont: 'rgba(145, 152, 189, 0.28)',
  },
  fonts: {
    accent: THEME_DEFAULT_FONTS.tokyo.dusk.accent
      ? THEME_DEFAULT_FONTS.tokyo.dusk.accent.value
      : 'unset',
    body: THEME_DEFAULT_FONTS.tokyo.dusk.body.value,
    heading: THEME_DEFAULT_FONTS.tokyo.dusk.headline.value,
  },
  shadows: {
    basic10: '0 0 $64 rgba(228, 232, 247, 0.15)',
  },
});
